import styled from "styled-components";

export const ExplorerOnboardingTooltipXButtonBox = styled.button`
    margin: 0 2rem 1rem auto;
    background-image: url("${props => props.theme.assets.images.close_modal_dialog_png.toString()}");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    height: 18px;
    width: 18px;
`;